import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { formatDistanceToNow, format } from 'date-fns';
import { Update as UpdateIcon, Person as PersonIcon } from '@mui/icons-material';

interface MetadataDisplayProps {
  updatedAt?: Date | any;
  updatedBy?: string;
  updatedByName?: string;
  displayFormat?: 'short' | 'long';
  showBy?: boolean;
}

/**
 * MetadataDisplay - Shows last updated timestamp and author
 *
 * Part of the critical fixes - displays when metadata toggle is enabled
 */
export const MetadataDisplay: React.FC<MetadataDisplayProps> = ({
  updatedAt,
  updatedBy,
  updatedByName,
  displayFormat = 'short',
  showBy = true
}) => {
  if (!updatedAt) return null;

  // Handle Firestore Timestamp or Date
  const date = updatedAt?.toDate ? updatedAt.toDate() : new Date(updatedAt);

  const formattedDate = displayFormat === 'short'
    ? formatDistanceToNow(date, { addSuffix: true })
    : format(date, 'MMM dd, yyyy h:mm a');

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        fontSize: '0.75rem',
        color: 'text.secondary',
        mt: 0.5
      }}
    >
      <Tooltip title={format(date, 'PPpp')}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <UpdateIcon sx={{ fontSize: 14 }} />
          <Typography variant="caption">{formattedDate}</Typography>
        </Box>
      </Tooltip>

      {showBy && updatedByName && (
        <Tooltip title={`Updated by ${updatedByName}`}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <PersonIcon sx={{ fontSize: 14 }} />
            <Typography variant="caption">{updatedByName}</Typography>
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};
